import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  ApproveCallGQL,
  RejectCallGQL,
  CallAttachmentsGQL,
  DeleteAttachmentGQL,
} from '../../../generated/graphql';

@Injectable({
  providedIn: 'root',
})
export class CallsService {
  constructor(
    private approveCallService: ApproveCallGQL,
    private rejectCallService: RejectCallGQL,
    private callAttachmentsService: CallAttachmentsGQL,
    private deleteAttachmentService: DeleteAttachmentGQL,
    private http: HttpClient
  ) {}

  approveCall(callId: number) {
    return this.approveCallService.mutate({ callId });
  }

  rejectCall(callId: number, reason: string | null) {
    return this.rejectCallService.mutate({ callId, reason });
  }

  getAttachments(callId: number) {
    return this.callAttachmentsService.fetch({ callId });
  }

  uploadAttachment(callId: number, file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`/api/calls/${callId}/attachments`, formData);
  }

  deleteAttachment(callId: number, attachmentId: number) {
    return this.deleteAttachmentService.mutate({ callId, attachmentId });
  }
}
